<div class="page-wrapper theme-background">
  <app-page-title-bar [pageTitle]="'disclaimer.title' | translate"></app-page-title-bar>
  <div class="page-body">
    <div class="container-xl">

      <div class="card">

        <!-- <div class="card-header">
          <h2 class="card-title">{{ 'disclaimer.title' | translate }}</h2>
        </div> -->

        <div class="card-body">

          <p class="text-secondary">
            {{ 'disclaimer.lastUpdateInfo' | translate : { lastUpdateDate: lastUpdateDate | localisedDate : 'mediumDate' } }}
          </p>

          <p>
            {{ 'disclaimer.welcomeMessage' | translate }}
          </p>

          <p>
            {{ 'disclaimer.introduction' | translate }}
          </p>

          @for(section of sections; track section.title; let idx = $index) {
            <div class="section">
              <h2>{{idx+1}}. {{ section.title }}</h2>
              <p [innerHTML]="section.content"></p>
            </div>
          }

        </div>
      </div>
    </div>
	</div>
</div>